// DIARIO DE BORDO PILOTO
const DiarioDeBordoPiloto =
	window.$cliente && window.$cliente.get('diario_bordo_default') === '1' ?
		'modules/layout/diario-de-bordo-piloto/default/main' :
		'modules/layout/diario-de-bordo-piloto/mg-siga/main'
const DiarioDeBordoMecanico =
	window.$cliente && window.$cliente.get('diario_bordo_default') === '1' ?
		'modules/layout/diario-de-bordo-mecanico/default/main' :
		'modules/layout/diario-de-bordo-mecanico/mg-siga/main'
const DiarioDeBordoOperador =
	window.$cliente && window.$cliente.get('diario_bordo_default') === '1' ?
		'modules/layout/diario-de-bordo-operador/default/main' :
		'modules/layout/diario-de-bordo-operador/mg-siga/main'

export default [
	// DIARIO DE BORDO PILOTO
	{
		modulo: 11,
		privilegio: 91,
		routerName: 'diario-de-bordo-piloto',
		routerPath: '/diario-de-bordo-piloto',
		componentName: 'DiarioDeBordoPiloto',
		componentPath: DiarioDeBordoPiloto,
		clientsComponentPath: [
			// id pm-es
			{
				clientId: [18],
				componentPath: 'modules/layout/diario-de-bordo-piloto/pm-es/main'
			},
			// id do siga, pmsp, bm-df
			{
				clientId: [9],
				componentPath: 'modules/layout/diario-de-bordo-piloto/mg-siga/main'
			},
			// id do gta-sergipe
			{
				clientId: [24],
				componentPath: 'modules/layout/diario-de-bordo-piloto/sergipe/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/diario-de-bordo-piloto/maranhao/main'
			},
			// id casa militar bahia
			{
				clientId: [8],
				componentPath: 'modules/layout/diario-de-bordo-piloto/cm-bahia/main'
			},
		],
		props: true
	},
	// DIÁRIO DE BORDO MECANICO
	{
		modulo: 12,
		privilegio: 105,
		routerName: 'diario-de-bordo-mecanico',
		routerPath: '/diario-de-bordo-mecanico',
		componentName: 'DiarioDeBordoMecanico',
		componentPath: DiarioDeBordoMecanico,
		clientsComponentPath: [
			// id pm-es
			{
				clientId: [18],
				componentPath: 'modules/layout/diario-de-bordo-mecanico/mg-siga/main'
			},
			// id do siga, pmsp, bm-df
			{
				clientId: [9],
				componentPath: 'modules/layout/diario-de-bordo-mecanico/mg-siga/main'
			},
			// id do gta-sergipe
			{
				clientId: [24],
				componentPath: 'modules/layout/diario-de-bordo-mecanico/sergipe/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/diario-de-bordo-mecanico/maranhao/main'
			},
			// id casa militar bahia
			{
				clientId: [8],
				componentPath: 'modules/layout/diario-de-bordo-mecanico/cm-bahia/main'
			}
		]
	},
	// DIÁRIO DE BORDO OPERADOR
	{
		modulo: 17,
		privilegio: 120,
		routerName: 'diario-de-bordo-operador',
		routerPath: '/diario-de-bordo-operador',
		componentName: 'DiarioDeBordoOperador',
		componentPath: DiarioDeBordoOperador,
		clientsComponentPath: [
			// id pm-es
			{
				clientId: [18],
				componentPath: 'modules/layout/diario-de-bordo-operador/mg-siga/main'
			},
			// id do siga, pmsp, bm-df
			{
				clientId: [9],
				componentPath: 'modules/layout/diario-de-bordo-operador/mg-siga/main'
			},
			// id do gta-sergipe
			{
				clientId: [24],
				componentPath: 'modules/layout/diario-de-bordo-operador/sergipe/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/diario-de-bordo-operador/maranhao/main'
			},
		]
	},
]
